module.exports = "/_next/static/images/240d3517c872bddaaaf5e0dd1f48a069-careers@0.75x.jpg.webp";